export default "__VITE_ASSET__CWSYhyCF__"